import { ScoreState } from "~/operations";

export const EXCEPTIONS_SCORE_STATES: ScoreState[] = [
  ScoreState.RiskAccepted,
  ScoreState.FalsePositive,
  ScoreState.Workaround,
  ScoreState.Disabled,
];
